import { gql } from "@apollo/client";

export const getHolidayByEntityId = gql`
query($entityId: String!){
  getHolidaysByEntityId(entityId: $entityId) {
    message
    response
  }
}
`;

// Holiday settings, balances and requests - every balance / preview response carries
// `lines` + `warnings`, the working shown behind the "i" buttons.
export const getHolidaySettingsQuery = gql`
query{
  getHolidaySettings {
    message
    response
  }
}
`;

export const getHolidayBalanceQuery = gql`
query($employeeId: String!, $date: String){
  getHolidayBalance(employeeId: $employeeId, date: $date) {
    message
    response
  }
}
`;

export const getEmployeeHolidaySettingQuery = gql`
query($employeeId: String!){
  getEmployeeHolidaySetting(employeeId: $employeeId) {
    message
    response
  }
}
`;

export const getHolidayRequestsQuery = gql`
query($filter: HolidayRequestFilter){
  getHolidayRequests(filter: $filter) {
    message
    response
  }
}
`;

export const previewHolidayRequestQuery = gql`
query($input: HolidayRequestInput!){
  previewHolidayRequest(input: $input) {
    message
    response
  }
}
`;

// approved holidays (to the end of this month by default) still needing a pay rate, each with
// a suggestion from the last duty the employee worked that month
export const getHolidayRatesNeededQuery = gql`
query($employeeId: String, $until: String){
  getHolidayRatesNeeded(employeeId: $employeeId, until: $until) {
    message
    response
  }
}
`;
